import { TReentrantLockTypeId as TReentrantLockTypeId$1, acquireRead as acquireRead$1, acquireWrite as acquireWrite$1, fiberReadLocks as fiberReadLocks$1, fiberWriteLocks as fiberWriteLocks$1, lock as lock$1, locked as locked$1, make as make$1, readLock as readLock$1, readLocks as readLocks$1, readLocked as readLocked$1, releaseRead as releaseRead$1, releaseWrite as releaseWrite$1, withLock as withLock$1, withReadLock as withReadLock$1, withWriteLock as withWriteLock$1, writeLock as writeLock$1, writeLocked as writeLocked$1, writeLocks as writeLocks$1 } from '../../internal/stm/tReentrantLock.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const TReentrantLockTypeId = TReentrantLockTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `TReentrantLock` is a reentrant read/write lock. Multiple readers may all
 * concurrently acquire read locks. Only one writer is allowed to acquire a
 * write lock at any given time. Read locks may be upgraded into write locks. A
 * fiber that has a write lock may acquire other write locks or read locks.
 *
 * The two primary methods of this structure are `readLock`, which acquires a
 * read lock in a scoped context, and `writeLock`, which acquires a write lock
 * in a scoped context.
 *
 * Although located in the STM package, there is no need for locks within STM
 * transactions. However, this lock can be quite useful in effectful code, to
 * provide consistent read/write access to mutable state; and being in STM
 * allows this structure to be composed into more complicated concurrent
 * structures that are consumed from effectful code.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @internal
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * Acquires a read lock. The transaction will suspend until no other fiber is
 * holding a write lock. Succeeds with the number of read locks held by this
 * fiber.
 *
 * @since 2.0.0
 * @category mutations
 */
const acquireRead = acquireRead$1;

/**
 * Acquires a write lock. The transaction will suspend until no other fibers
 * are holding read or write locks. Succeeds with the number of write locks
 * held by this fiber.
 *
 * @since 2.0.0
 * @category mutations
 */
const acquireWrite = acquireWrite$1;

/**
 * Retrieves the number of acquired read locks for this fiber.
 *
 * @since 2.0.0
 * @category mutations
 */
const fiberReadLocks = fiberReadLocks$1;

/**
 * Retrieves the number of acquired write locks for this fiber.
 *
 * @since 2.0.0
 * @category mutations
 */
const fiberWriteLocks = fiberWriteLocks$1;

/**
 * Just a convenience method for applications that only need reentrant locks,
 * without needing a distinction between readers / writers.
 *
 * See `TReentrantLock.writeLock`.
 *
 * @since 2.0.0
 * @category mutations
 */
const lock = lock$1;

/**
 * Determines if any fiber has a read or write lock.
 *
 * @since 2.0.0
 * @category mutations
 */
const locked = locked$1;

/**
 * Makes a new reentrant read/write lock.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * Obtains a read lock in a scoped context.
 *
 * @since 2.0.0
 * @category mutations
 */
const readLock = readLock$1;

/**
 * Retrieves the total number of acquired read locks.
 *
 * @since 2.0.0
 * @category mutations
 */
const readLocks = readLocks$1;

/**
 * Determines if any fiber has a read lock.
 *
 * @since 2.0.0
 * @category mutations
 */
const readLocked = readLocked$1;

/**
 * Releases a read lock held by this fiber. Succeeds with the outstanding
 * number of read locks held by this fiber.
 *
 * @since 2.0.0
 * @category mutations
 */
const releaseRead = releaseRead$1;

/**
 * Releases a write lock held by this fiber. Succeeds with the outstanding
 * number of write locks held by this fiber.
 *
 * @since 2.0.0
 * @category mutations
 */
const releaseWrite = releaseWrite$1;

/**
 * Runs the specified workflow with a lock.
 *
 * @since 2.0.0
 * @category mutations
 */
const withLock = withLock$1;

/**
 * Runs the specified workflow with a read lock.
 *
 * @since 2.0.0
 * @category mutations
 */
const withReadLock = withReadLock$1;

/**
 * Runs the specified workflow with a write lock.
 *
 * @since 2.0.0
 * @category mutations
 */
const withWriteLock = withWriteLock$1;

/**
 * Obtains a write lock in a scoped context.
 *
 * @since 2.0.0
 * @category mutations
 */
const writeLock = writeLock$1;

/**
 * Determines if a write lock is held by some fiber.
 *
 * @since 2.0.0
 * @category mutations
 */
const writeLocked = writeLocked$1;

/**
 * Computes the number of write locks held by fibers.
 *
 * @since 2.0.0
 * @category mutations
 */
const writeLocks = writeLocks$1;

export { TReentrantLockTypeId, acquireRead, acquireWrite, fiberReadLocks, fiberWriteLocks, lock, locked, make, readLock, readLocked, readLocks, releaseRead, releaseWrite, withLock, withReadLock, withWriteLock, writeLock, writeLocked, writeLocks };
